import { CURRENT } from 'self-service-api/constants/VersionTypes';
export const reduceProductsResponse = data => {
  const productVersions = data.reduce((acc, product) => {
    const keyedVersions = {};
    product.productVersions.forEach(version => {
      keyedVersions[version.skuId] = version;
    });
    return Object.assign({}, acc, {}, keyedVersions);
  }, {});
  const skuMap = Object.values(productVersions).reduce((acc, productVersion) => {
    const skus = Object.assign({}, acc, {
      [productVersion.skuId]: productVersion
    });
    productVersion.quantityPackDetails.forEach(quantityPack => {
      skus[quantityPack.skuId] = quantityPack;
    });
    return skus;
  }, {});
  const products = data.reduce((acc, product) => {
    const {
      id
    } = product;
    return Object.assign({}, acc, {
      [id]: Object.assign({}, product, {
        productVersions: product.productVersions.map(({
          skuId
        }) => skuId)
      })
    });
  }, {});
  const apiNameToProductId = Object.values(products).reduce((acc, {
    apiName,
    id
  }) => Object.assign({}, acc, {
    [apiName]: id
  }), {});
  const productLineLevelToProductId = Object.values(products).reduce((acc, {
    productLine,
    productLevel,
    id
  }) => {
    if (productLine) {
      if (productLine in acc) {
        return Object.assign({}, acc, {
          [productLine]: Object.assign({}, acc[productLine], {
            [productLevel]: id
          })
        });
      }

      return Object.assign({}, acc, {
        [productLine]: {
          [productLevel]: id
        }
      });
    }

    return acc;
  }, {});
  /**
   * @deprecated as part of TB, prefer {@link quantityPackApiNameToProductId}
   */

  let parcelNameToProductId = Object.values(productVersions).reduce((acc, productVersion) => {
    const {
      productId
    } = productVersion;
    const map = Object.assign({}, acc);

    if (productVersion.versionType === CURRENT) {
      if (productVersion.parcelName) map[productVersion.parcelName] = productId;
      productVersion.quantityPackDetails.forEach(quantityPack => {
        if (quantityPack.parcelName && !productVersion.isBundle) map[quantityPack.parcelName] = productId;
      });
    }

    return map;
  }, {}); // sort the keys for easier scanning in redux

  parcelNameToProductId = Object.keys(parcelNameToProductId).sort().reduce((obj, key) => {
    obj[key] = parcelNameToProductId[key];
    return obj;
  }, {});
  const quantityPackApiNameToProductId = Object.values(productVersions).reduce((acc, productVersion) => {
    if (productVersion.versionType === CURRENT) {
      productVersion.quantityPackDetails.forEach(quantityPack => {
        const {
          productId,
          productApiName,
          quantityPackApiName
        } = quantityPack;

        if (quantityPackApiName) {
          acc[quantityPackApiName] = Object.assign({}, acc[quantityPackApiName], {
            [productApiName]: productId
          });
        }
      });
    }

    return acc;
  }, {});
  return {
    productMap: products,
    productVersions,
    skuMap,
    apiNameToProductId,
    productLineLevelToProductId,
    parcelNameToProductId,
    quantityPackApiNameToProductId,
    rawProductList: data
  };
};